import { ActionIcon, Box, Group, Text, Tooltip, UnstyledButton } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import { NotificationResponseType } from "constants/types/notification";
import { relativeTime } from "../../../../utils";
import classes from "../../NotificationBell.module.css";
import { TypeIcon } from "../TypeIcon/TypeIcon";

interface NotificationItemProps {
  item: NotificationResponseType;
  isLoading: boolean;
  onClick: () => void;
  onMarkRead: (e: React.MouseEvent) => void;
}

export function NotificationItem({ item, isLoading, onClick, onMarkRead }: NotificationItemProps) {
  return (
    <UnstyledButton
      onClick={onClick}
      disabled={isLoading}
      style={{ display: "block", width: "100%" }}
    >
      <Group
        gap={8}
        align="flex-start"
        wrap="nowrap"
        className={[
          classes.item,
          !item.isRead ? classes.unread : "",
          isLoading ? classes.disabled : "",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <TypeIcon type={item.type} />

        <Box style={{ flex: 1, minWidth: 0 }}>
          <Group justify="space-between" align="flex-start" gap={4} wrap="nowrap">
            <Text size="sm" fw={item.isRead ? 400 : 600} lineClamp={1} lh={1.4} style={{ flex: 1 }}>
              {item.title}
            </Text>

            {!item.isRead && (
              <Tooltip label="Đánh dấu đã đọc" position="left" withArrow>
                <ActionIcon
                  size={18}
                  variant="subtle"
                  color="blue"
                  radius="xl"
                  className={classes.markBtn}
                  onClick={onMarkRead}
                >
                  <IconCheck size={11} />
                </ActionIcon>
              </Tooltip>
            )}
          </Group>

          <Text size="xs" c="dimmed" lineClamp={2} mt={3} lh={1.4}>
            {item.body}
          </Text>

          <Text size="xs" mt={4} lh={1} c={item.isRead ? "dimmed" : "blue.5"}>
            {relativeTime(item.createdAt)}
          </Text>
        </Box>
      </Group>
    </UnstyledButton>
  );
}
